<script>

// import menuGroup from './menugroup'
// import annotationmenu from './annotation-menu'
import store from '@/store'
import sensaroption from './sensar-option'

export default {
    name: 'configuratordrawer',
    components: {
        // menuGroup,
        // annotationmenu,
        sensaroption
    },
    data: () => ({
        modelroute: '/models'
    }),
    computed: {
        menu () {
            return this.$store.getters['menu/getAll']
        },
        annotations () {
            return this.$store.getters['annotations/getAll']
        },
            sceneLoaded () {
      return store.state.scenes.sceneLoaded
    },
    },
    methods: {
    }   
}
</script>

<template>
  <sensaroption
    v-if="sceneLoaded"
    optionname="hochiminh"
  >
  </sensaroption>
</template>